import * as angular from "angular";
import { Component } from "../../../component-decorator";
import * as _ from "lodash";
import downloadFile from "../../../../app/download-file";

@Component({
  componentName: "appRomaneio",
  template: require("./romaneio.html"),
  controllerAs: "vm",
})
export class RomaneioComponent implements angular.IController {
  public user;
  public alerts = [];
  public loadingSearch = false;
  public packages = null;
  public total = 0;
  public checkboxes = { checked: true, items: {} };
  public sort = "dataCriacao:desc";
  public pedido;
  public errors = {};
  public isLoadingPrint = false;

  constructor(
    private $scope,
    private $state,
    private $stateParams,
    private $uibModal,
    private $filter,
    private $controller,
    private $q: angular.IQService,
    private Pedido,
    private Auth,
    private Perfil,
    private Cep,
    private Endereco,
    private localStorageService,
    private Coleta,
    private Historico,
    private Encomenda,
    private $mdToast
  ) {
    "ngInject";

    this.user = localStorageService.get("user");
  }

  public async $onInit() {
    const values = await this.$q.all([
      this.Perfil.getClienteData(this.user.id),
      this.carregarListaEncomendas(),
    ]);

    this.user = values[0];
    this.user.ativo = this.user.situacaoCadastral === "ATIVO";
  }

  public addAlert(msg, type) {
    this.alerts.push({ msg, type });
  }

  public closeAlert(index) {
    this.alerts.splice(index, 1);
  }

  public sortContains(coluna) {
    return this.sort.split(":")[0] === coluna;
  }

  public sortByColumn(coluna) {
    if (!coluna) {
      return;
    }

    const order = this.sort.split(":")[1] === "asc" ? "desc" : "asc";

    this.sort = coluna + ":" + order;
    this.search(coluna);
  }

  public async search(coluna?: string) {
    try {
      const data = await this.Historico.getListaEncomendas(
        {
          situacaoPedido: ["Nova", "NaoColetada"],
          exigirEtiquetaImpressa: true,
          sort: this.sort,
        },
        undefined,
        undefined
      );

      this.pedido = this.pedido || {};
      this.pedido.remessas = data.pedidos;
      this.packages = data.pedidos;
      this.total = this.pedido.remessas.length;

      // Marcar todos os checkboxes por padrão, preservando a seleção manual
      // já feita pelo usuário (a lista é recarregada a cada reordenação)
      const selecaoAnterior = this.checkboxes.items || {};
      this.checkboxes.items = {};
      this.pedido.remessas.forEach(remessa => {
        this.checkboxes.items[remessa.id] =
          selecaoAnterior[remessa.id] === undefined
            ? true
            : selecaoAnterior[remessa.id];
      });
      this.checkboxes.checked = this.pedido.remessas.every(
        remessa => this.checkboxes.items[remessa.id] === true
      );
    } catch (e) {
      this.pedido = { remessas: [] };
      this.packages = [];
    }
  }

  public isEmpty() {
    if (!this.pedido || !this.pedido.remessas) {
      return true;
    }

    return !this.hasSelected();
  }

  public hasSelected() {
    return Object.values(this.checkboxes.items).some(item => item === true);
  }

  public getSelectedCount(): number {
    if (!this.checkboxes.items) {
      return 0;
    }
    return Object.values(this.checkboxes.items)
      .filter(selected => selected === true)
      .length;
  }

  public selectAll() {
    const allSelected = this.checkboxes.checked;

    if (this.pedido && this.pedido.remessas) {
      this.pedido.remessas.forEach(remessa => {
        this.checkboxes.items[remessa.id] = allSelected;
      });
    }
  }

  public async imprimirRomaneio() {
    this.isLoadingPrint = true;

    try {
      // Verifica se há alguma encomenda selecionada
      const selectedIds = Object.entries(this.checkboxes.items)
        .filter(([id, selected]) => selected === true)
        .map(([id]) => parseInt(id, 10));

      // Se não houver selecionadas, usa todas
      const idsToProcess = selectedIds.length > 0
        ? selectedIds
        : this.pedido.remessas.map(r => r.id);

      if (idsToProcess.length === 0) {
        this.addAlert("Não há encomendas para imprimir romaneio.", "warning");
        this.isLoadingPrint = false;
        return;
      }

      // Prepara o payload para a API
      const payload = {
        idsEncomendas: idsToProcess,
      };

      console.log("Chamando API POST /romaneio-coleta/planejado");
      console.log("Payload:", payload);
      console.log(`Total de encomendas selecionadas: ${idsToProcess.length}`);

      // Chama a API real
      const response = await this.Pedido.printRomaneio(payload).$promise;

      if (response && response.response) {
        // Faz download do PDF
        downloadFile(response.response, 'application/pdf', `romaneio-${Date.now()}.pdf`);

        const toast = this.$mdToast
          .simple()
          .textContent(`Romaneio gerado com ${idsToProcess.length} encomenda(s)`)
          .action("OK")
          .hideDelay(5000);
        toast._options.position = "bottom center";

        this.$mdToast.show(toast);
      } else {
        throw new Error("Resposta inválida da API");
      }
    } catch (error) {
      console.error("Erro ao imprimir romaneio:", error);

      // Trata erros específicos
      let errorMessage = "Erro ao gerar romaneio. Tente novamente.";

      if (error.data && error.data.message) {
        errorMessage = error.data.message;
      } else if (error.statusText) {
        errorMessage = `Erro: ${error.statusText}`;
      }

      this.addAlert(errorMessage, "danger");
    } finally {
      this.isLoadingPrint = false;
    }
  }

  servicosAdicionais(encomenda) {
    const servicos = [];
    if (encomenda) {
      if (encomenda.ar === true) {
        servicos.push("AR");
      }
      if (encomenda.maoPropria === true) {
        servicos.push("MP");
      }
      if (Number(encomenda.valorDeclarado) > 0) {
        const valorDecl = this.$filter("currency")(
          encomenda.valorDeclarado,
          "R$ "
        );
        servicos.push("VD " + valorDecl);
      }
    }

    return servicos.join(" ");
  }

  private async carregarListaEncomendas(force = true) {
    try {
      return this.search();
    } catch (err) {
      console.log(err);
    }
  }

  private tratarErrosBackEnd(err) {
    this.errors = {};
    if (err != null && err.erro) {
      this.addAlert(err.erro, "danger");
    } else if (err != null && err[0] != null) {
      this.addAlert(err[0].message || err[0].erro, "danger");
    } else if (err.data && err.data.erro) {
      this.addAlert(err.data.erro, "danger");
    } else if (err.data && err.data.length) {
      for (const erro in err.data) {
        if (err.data.hasOwnProperty(erro)) {
          this.$scope.$emit("erroEncontrado", err.data[erro].message);
        }
      }
    }
  }
}


